import React from 'react'

import _ from 'lodash'

import { Form, Input, message, Modal, Select } from 'antd'

import { observer } from 'mobx-react-lite'

import { VendorUserRoles } from 'common/server/server_types'

import { useVendorStores } from 'vendor/hooks/use-stores'

type NewUsersModalProps = {
  visible: boolean
  hide: () => void
}

const roleOptions = Object.values(VendorUserRoles)

const NewUsersModal = observer<NewUsersModalProps>(({ visible, hide }) => {
  const { vendorSettingStore } = useVendorStores()
  const [form] = Form.useForm()

  const inviteUsers = () => {
    form.validateFields().then(async () => {
      const { emails, role } = form.getFieldsValue()

      try {
        await vendorSettingStore.inviteUsers(emails, role)
        message.success('Successfully added new users')
        vendorSettingStore.indexUsers()
        hide()
        form.resetFields()
      } catch (err) {
        console.error(`Unable to invite users: `, err?.response?.data)
        message.error(`Unable to invite users: ${_.get(err, 'response.data.error', '')}`, 3)
      }
    })
  }

  return (
    <Modal title="Add New Users" open={visible} okText="Invite users" onOk={inviteUsers} onCancel={hide}>
      <Form
        form={form}
        name="new-users-form"
        initialValues={{ role: VendorUserRoles.USER }}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        onValuesChange={(v) => {
          // Better UX if we trim the emails for you, otherwise you might not know what's wrong
          if (v?.emails) {
            form.setFieldsValue({ emails: _.trim(v.emails.toLowerCase()) })
          }
        }}
      >
        <Form.Item
          name="emails"
          label="Email(s)"
          rules={[{ required: true, message: 'Please enter one or more emails!' }]}
          extra="Comma separated list of emails to invite"
        >
          <Input placeholder="user1@mycompany.com,user2@mycompany.com" />
        </Form.Item>
        <Form.Item name="role" label="Role">
          <Select>
            {roleOptions.map((role) => (
              <Select.Option key={role} value={role}>
                {role}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
})

export default NewUsersModal
